import React from "react";
import "./index.less";

class informationCollectionList extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {};
    }

    componentDidMount() {
        document.getElementsByTagName("body")[0].style.cssText =
            "background: #F4F4F5 !important";
    }

    render() {
        return (
            <div className="informationCollectionListBox">
                <div>
                    <h3 style={{ textAlign: "center" }}>个人信息收集清单 </h3>
                    {/* <h3>第三方SDK列表</h3> */}
                    <div className="scorll-view">
                        {/* <!-- 一个table表格 --> */}
                        <table className="table">
                            {/* <!-- 表头部分thead --> */}
                            <thead>
                                {/* <!-- 表头行tr --> */}
                                <tr>
                                    {/* <!-- 表头的列th --> */}
                                    <th
                                        colSpan="5"
                                        style={{
                                            textAlign: "center",
                                            backgroundColor: "#cccccc",
                                        }}
                                    >
                                        <strong>个人信息收集清单</strong>
                                    </th>
                                </tr>
                            </thead>

                            {/* <!-- 表格内容部分tbody --> */}
                            <tbody>
                                {/* <!-- 表格内容的第一行tr --> */}
                                <tr>
                                    {/* <!-- 列td --> */}
                                    <td>
                                        <strong>业务场景</strong>
                                    </td>
                                    <td>
                                        <strong>业务子场景</strong>
                                    </td>
                                    <td>收集目的</td>
                                    <td>收集方式</td>
                                    <td>个人信息字段</td>
                                </tr>

                                {/* <!-- 表格内容的第二行tr --> */}
                                <tr>
                                    {/* <!-- 列td --> */}
                                    <td>注册、登录</td>
                                    <td>登录注册</td>
                                    <td>用于注册、登录远程慧联APP账号</td>
                                    <td>用户输入、APP收集</td>
                                    <td>手机号码、验证码、密码、微信OpenID</td>
                                </tr>

                                {/* <!-- 表格内容的第三行tr --> */}
                                <tr>
                                    {/* <!-- 列td --> */}
                                    <td rowSpan="4">站点服务</td>
                                    <td>寻找充电站</td>
                                    <td>推荐附近的充电站</td>
                                    <td>APP收集</td>
                                    <td>位置信息</td>
                                </tr>
                                <tr>
                                    <td>寻找服务网点</td>
                                    <td>推荐附近的服务网点</td>
                                    <td>APP收集</td>
                                    <td>位置信息</td>
                                </tr>
                                <tr>
                                    <td>寻找甲醇站</td>
                                    <td>推荐附近的甲醇站</td>
                                    <td>APP收集</td>
                                    <td>位置信息</td>
                                </tr>
                                <tr>
                                    <td>寻找运营商</td>
                                    <td>推荐附近的运营商</td>
                                    <td>APP收集</td>
                                    <td>位置信息</td>
                                </tr>
                                <tr>
                                    <td>预约咨询</td>
                                    <td>在线预约</td>
                                    <td>
                                        当您进行在线预约租车时，我们的工作人员会联系您
                                    </td>
                                    <td>用户输入</td>
                                    <td>姓名、手机号码、城市</td>
                                </tr>
                                <tr>
                                    <td>扫码充电</td>
                                    <td>扫码充电</td>
                                    <td>
                                        当您启动充电时，输入车牌号，部分充电场站可以限时免停车费，以及开具发票
                                    </td>
                                    <td>用户输入、APP收集</td>
                                    <td>
                                        车牌号、订单号、发票抬头（姓名）、税号、发票金额、接收电子发票的邮箱
                                    </td>
                                </tr>
                                <tr>
                                    <td>实名认证</td>
                                    <td>使用租车服务并选择电子合同签署</td>
                                    <td>
                                        为满足法律法规及监管要求、保护您的人身财产安全以及满足我们的风控管理要求
                                    </td>
                                    <td>用户输入/APP收集</td>
                                    <td>
                                        姓名、身份证号码、身份证正反照片、手机号码
                                    </td>
                                </tr>
                                <tr>
                                    <td>合同签署</td>
                                    <td>签署电子合同</td>
                                    <td>为您提供电子合同签署服务</td>
                                    <td>用户输入/APP收集</td>
                                    <td>电子合同相关文件</td>
                                </tr>
                                <tr>
                                    <td>支付功能</td>
                                    <td>
                                        买充电卡、还租车账单、支付租车首期款、支付ETC开通费
                                    </td>
                                    <td>进行微信支付、支付宝支付</td>
                                    <td>用户输入/APP收集</td>
                                    <td>
                                        金额、支付方式、订单号、订单状态、支付记录
                                    </td>
                                </tr>
                                <tr>
                                    <td>在线客服</td>
                                    <td>相应用户相关场景</td>
                                    <td>
                                        通过在线客服、客服热线与我们进行互动
                                    </td>
                                    <td>用户输入</td>
                                    <td>
                                        用户账号、联系方式、沟通信息（包括文件/文字/图片/音视频/通话记录形式）
                                    </td>
                                </tr>
                                <tr>
                                    <td>保障运营与安全运行</td>
                                    <td>保障运营与安全运行</td>
                                    <td>
                                        为维护服务正常运行，保障账户和交易安全
                                    </td>
                                    <td>APP收集</td>
                                    <td>
                                        日志信息、设备信息，包括您的硬件设备型号、屏幕宽度和高度、您所使用的软件版本信息、您的操作系统及版本、您的IP地址、移动网络信息、您的设备ID、设备制造商、设备型号、运营商、运行中进程、Android
                                        ID、IDFA、IDFV、OAID、UUID
                                    </td>
                                </tr>
                                <tr>
                                    <td>在线活动</td>
                                    <td>参与活动的场景</td>
                                    <td>
                                        当您通过在线活动中奖了，需要联系您时
                                    </td>
                                    <td>用户输入</td>
                                    <td>
                                        姓名、手机号码、微信OpenID、收货地址
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan="5">用车管理</td>
                                    <td>绑定车辆</td>
                                    <td>
                                        您可以通过绑定车辆使用维保预约、年审预约、查看车辆信息功能
                                    </td>
                                    <td>用户输入</td>
                                    <td>行驶证照片</td>
                                </tr>
                                <tr>
                                    <td>车辆授权</td>
                                    <td>
                                        当您租赁了车辆，可以把车辆分配给您的司机进行车辆信息的查看
                                    </td>
                                    <td>用户输入</td>
                                    <td>司机姓名、手机号码</td>
                                </tr>
                                <tr>
                                    <td>维保年审、年审预约</td>
                                    <td>
                                        您可以通过维保预约、年审预约对您使用的车辆进行维修保养、年审年检
                                    </td>
                                    <td>用户输入</td>
                                    <td>姓名、手机号码、地理位置信息</td>
                                </tr>
                                <tr>
                                    <td>安全培训</td>
                                    <td>
                                        您可以通过安全培训，提升用车安全意识，保障安全驾驶
                                    </td>
                                    <td>APP收集</td>
                                    <td>
                                        课程名称、学习时长、学习课时数、完成状态、课程浏览记录、本月排名、我的证书
                                    </td>
                                </tr>
                                <tr>
                                    <td>租车订单</td>
                                    <td>您可以租车订单，查询订单详情</td>
                                    <td>用户输入</td>
                                    <td>车牌号、租期、计划提车日期、提车点</td>
                                </tr>
                                <tr>
                                    <td rowSpan="2">ETC服务</td>
                                    <td>设备获取、生成订单</td>
                                    <td>
                                        您可以通过申请开通ETC，享受高速通行优惠
                                    </td>
                                    <td>用户输入</td>
                                    <td>车牌号、姓名、手机号码、收货地址</td>
                                </tr>
                                <tr>
                                    <td>签约记录、ETC账单</td>
                                    <td>
                                        您可以通过签约记录、ETC账单查询账单详情
                                    </td>
                                    <td>APP收集</td>
                                    <td>手机号码</td>
                                </tr>
                                <tr>
                                    <td rowSpan="3">商城-服务</td>
                                    <td>匹配最近门店</td>
                                    <td>推荐附近的门店</td>
                                    <td>APP收集</td>
                                    <td>位置信息</td>
                                </tr>
                                <tr>
                                    <td>下单及订单管理</td>
                                    <td>生成订单以完成购买</td>
                                    <td>APP收集及用户输入</td>
                                    <td>
                                        订单信息（商品规格、订单金额、订单编号、订单状态、支付状态）、核销信息（核销门店、核销时间）
                                    </td>
                                </tr>
                                <tr>
                                    <td>发票开具</td>
                                    <td>为您开具相应的发票</td>
                                    <td>用户输入</td>
                                    <td>
                                        发票抬头（姓名）、税号、发票金额、接收电子发票的邮箱
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
export default informationCollectionList;



// WEBPACK FOOTER //
// ./src/informationCollectionList/index/index.js